<template>
  <div class="flex items-center pagination" v-if="dataSet.total > 0">
    <div v-if="showCountFrom" class="items-center text-onyx text-sm">{{ dataSet.from }}-{{ dataSet.to }} of {{ dataSet.total }}</div>
    <vs-pagination
      :max="getMaxPagination"
      class="flex-1"
      :total="totalPages"
      v-model="currentx"
      @input="changePage"
      icon-pack="feather"
      prev-icon="icon-chevron-left"
      next-icon="icon-chevron-right">
    </vs-pagination>
  </div>
</template>

<script>
import event from "../event";

export default {
  name: "pagination",
  props: {
    dataSet: {
      type: Object,
      required: true
    },
    dataParam: {
      type: String,
      default: ''
    },
    showCountFrom: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentx: this.dataSet.current_page,
    }
  },
  computed: {
    getMaxPagination() {
        if (this.totalPages <= 9) {
            return 0;
        }

        return 9;
    },
    totalPages() {
      return Math.ceil(this.dataSet.total / this.dataSet.per_page);
    }
  },
  methods: {
    changePage(pageNumber) {
      let page = this.dataSet.current_page;

      if (page === pageNumber) return;

      let page_slug = location.pathname.replace(/^\/+|\/+$/g, '');

      if (['company-results', 'companies'].includes(page_slug) && this.dataParam !== '') {

        const jobsUrlWithParams = new URL(this.dataParam);
        jobsUrlWithParams.searchParams.delete("page");
        jobsUrlWithParams.searchParams.append("page", pageNumber);
        event.bus.$emit('selected-company-filter', jobsUrlWithParams.href);

      } else {

        let querySearch = location.search;
        if ((this.dataParam !== '') && (querySearch.includes(this.dataParam) === false)) {
          querySearch = querySearch + (querySearch.includes('?') ? '&' : '?') + this.dataParam;
        }

        const jobsUrlWithParams = new URL(location.origin + location.pathname + querySearch);
        jobsUrlWithParams.searchParams.delete("page");
        jobsUrlWithParams.searchParams.append("page", pageNumber);

        location.href = jobsUrlWithParams;
      }
    }
  }
};
</script>

<style lang="scss">
.pagination {
  .vs-pagination--li span {
    font-size: 17.5px;
    font-weight: 400
  }
  .vs-pagination--ul {
    margin: 0 10px;
  }
  .vs-pagination--mb {
    display: flex;
    justify-content: center !important;
    width: 100% !important;
    margin-bottom: 0 !important;
  }
  .vs-pagination--buttons i {
    font-size: 24px;
  }
  .vs-pagination--buttons {
    width: 40px;
    height: 40px;
  }
  @screen md {
    .vs-pagination--nav {
      margin-right: 56px;
    }
  }
}
</style>
